module.exports = __webpack_public_path__ + "media/images/press_kit/virgin_voyages/main-dbe055f71fad2f26878b4a35faa29a26.png";